<template>
<div class="page-wrapper">
	<div class="page page-settings">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">Settings</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">Payment</span>
				</h1>
			</div>
			<div class="page-content">
				<!-- Moota -->
				<div class="integration-item box mb-3 p-0">
					<div class="integration-app">
						<div class="wrapper">
							<div class="integration-app-logo">
								<img src="/images/logo-small-moota.png" alt="Moota">
							</div>
							<button
								type="button"
								class="integration-app-button btn btn-primary"
								v-if="mootaAccounts.length === 0"
								@click="isShowModalMoota = true">
								+ Add Moota Account
							</button>
						</div>
					</div>
					<integration-accounts
						:editable="true"
						:name="'Moota Account'"
						:accounts="mootaAccounts"
						@remove="removeIntegration"
						@edit="editMoota">
					</integration-accounts>
				</div>

				<!-- Midtrans -->
				<div class="integration-item box p-0" v-if="isAdmin">
					<div class="integration-app">
						<div class="wrapper">
							<div class="integration-app-logo">
								<img src="/images/logo-small-midtrans.png" alt="Midtrans">
							</div>
							<button
								type="button"
								class="integration-app-button btn btn-primary"
								v-if="midtransAccounts.length === 0"
								@click="isMidtransFormVisible = true">
								<span>+ Add Midtrans Account</span>
							</button>
						</div>
					</div>
					<integration-accounts
						:editable="true"
						:name="'Midtrans Account'"
						:accounts="midtransAccounts"
						@remove="removeIntegration"
						@edit="editMidtrans">
					</integration-accounts>
				</div>
			</div>
		</div>
	</div>
	<div class="modals">
		<!-- Moota -->
		<modal
			class="integration-modal"
			:size="'large'"
			v-if="isShowModalMoota"
			@close="isShowModalMoota = false">
			<div slot="header"><h3>Moota</h3></div>
			<div slot="body" class="row">
				<!-- TUTORIAL -->
				<div class="col-md-6">
					<h4 class="modal-title">How to Integrate</h4>
					<div class="integration-video embed-responsive embed-responsive-16by9">
						<iframe src="https://www.youtube.com/embed/0jTTXdgilnA?rel=0"></iframe>
					</div>
				</div>
				<!-- CONFIG -->
				<div class="col-md-6">
					<h4 class="modal-title">Configurations</h4>
					<div class="integration-explanation text-left mb-3">
						<div class="title">Edit your Moota API Push Notification settings:</div>
						<div class="description"><i class="material-icons checklist">check</i> URL: https://api.ostock.id/integration/moota/webhook</div>
						<div class="description"><i class="material-icons checklist">check</i> Min: 0</div>
						<div class="description"><i class="material-icons checklist">check</i> Max: 999</div>
					</div>
					<div class="integration-actions">
						<!-- <div class="input-group">
							<input type="text" class="input form-control" placeholder="Moota API Key" v-model="mootaApiKey">
							<div class="input-group-prepend">
								<button
									v-if="actionType === 'add'"
									type="button"
									class="input-group-text btn btn-primary"
									:disabled="mootaApiKey.length === 0"
									:class="{ 'is-loading': isAddingMoota }"
									@click="addMoota">Integrate
								</button>
								<button
									v-else
									type="button"
									class="input-group-text btn btn-primary"
									:disabled="mootaApiKey.length === 0"
									:class="{ 'is-loading': isAddingMoota }"
									@click="updateMoota">Update
								</button>
							</div>
						</div> -->
						<div class="form-group">
							<label><b>API Key</b></label>
							<input type="text" class="input form-control" placeholder="Moota API Key" v-model="mootaApiKey">
						</div>
						<div class="row">
							<div class="col-sm-6">
								<div class="form-group">
									<label><b>Match For</b></label>
									<select class="form-control" v-model="matchFor">
										<option v-for="(item, index) in matchForOptions" :key="index" :value="item.value">{{ item.label }}</option>
									</select>
								</div>
							</div>
							<div class="col-sm-6">
								<div class="form-group">
									<label><b>Status Change</b></label>
									<select class="form-control" v-model="statusChange">
										<option v-for="(item, index) in statusChangeOptions" :key="index" :value="item.value">{{ item.label }}</option>
									</select>
								</div>
							</div>
						</div>

						<div class="float-right">
							<button
								v-if="actionType === 'add'"
								type="button"
								class="input-group-text btn btn-primary"
								:disabled="mootaApiKey.length === 0"
								:class="{ 'is-loading': isAddingMoota }"
								@click="addMoota">Integrate
							</button>
							<button
								v-else
								type="button"
								class="input-group-text btn btn-primary"
								:disabled="mootaApiKey.length === 0"
								:class="{ 'is-loading': isAddingMoota }"
								@click="updateMoota">Update
							</button>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalMoota = false">{{ $t('Close') }}</button>
			</div>
		</modal>

		<!-- Midtrans -->
		<midtrans-integration
			:account="selectedAccount"
			@insert="addAccount"
			@close="isMidtransFormVisible = false"
			v-if="isMidtransFormVisible"
		/>
	</div>

	<notifications group="payment" position="bottom right" />
</div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import IntegrationAccounts from '@/components/IntegrationAccounts.vue';
import MidtransIntegration from '@/components/MidtransIntegration.vue';
import integrationApi from '@/api/integration';
import { duplicateVar } from '@/lib/helper';
import { statusChangeOptions } from '@/lib/statics';

// const defaultSelectedProduct = { _id: 0, name: 'Select Product' };

export default {
	name: 'settingsPayment',
	components: {
		Modal,
		IntegrationAccounts,
		MidtransIntegration,
	},
	data() {
		return {
			mootaApiKey: '',
			matchFor: 'pending',
			statusChange: 'processing',
			isShowModalMoota: false,
			isAddingMoota: false,
			integrationId: '',
			actionType: 'add',
			matchForOptions: [
				{
					value: 'pending',
					label: 'Pending Orders',
				},
				{
					value: 'unpaid',
					label: 'Unpaid Orders',
				},
			],
			statusChangeOptions: duplicateVar(statusChangeOptions),
			selectedAccount: null,
			isMidtransFormVisible: false,
		};
	},
	methods: {
		...mapActions({
			fetchAccounts: 'settings/fetchAccounts',
			addAccount: 'settings/addAccount',
			removeAccount: 'settings/removeAccount',
			updateAccount: 'settings/updateAccount',
		}),
		removeIntegration(id) {
			this.removeAccount(id);
			const callback = (response) => {
				// console.log(response);
			};
			integrationApi.remove(id, callback);
		},
		addMoota() {
			this.isAddingMoota = true;
			const apiKey = this.mootaApiKey.trim();
			const params = {
				api_key: apiKey,
				match_for: this.matchFor,
				status_change: this.statusChange,
			};
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}

				// clear fields
				this.mootaApiKey = '';

				this.isAddingMoota = false;
				this.isShowModalMoota = false;
				this.actionType = 'add';
				this.integrationId = '';

				this.$notify({
					group: 'payment',
					title: 'Moota',
					text: 'Successfully Connected to Moota',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'payment',
						title: 'Moota',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingMoota = false;
			};
			integrationApi.addMoota(params, callback, errorCallback);
		},
		editMoota(id) {
			this.integrationId = id;
			this.actionType = 'edit';
			this.isShowModalMoota = true;
			const moota = this.accounts.find(curr => curr._id === id);
			this.mootaApiKey = moota.data.api_key;
			this.matchFor = moota.data.match_for || 'pending';
			this.statusChange = moota.data.status_change || 'processing';
		},
		updateMoota() {
			this.isAddingMoota = true;
			const id = this.integrationId;
			const apiKey = this.mootaApiKey.trim();
			const params = {
				api_key: apiKey,
				match_for: this.matchFor,
				status_change: this.statusChange,
			};
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.updateAccount(account);
				}

				// clear fields
				this.mootaApiKey = '';

				this.isAddingMoota = false;
				this.isShowModalMoota = false;
				this.actionType = 'add';
				this.integrationId = '';

				this.$notify({
					group: 'payment',
					title: 'Moota',
					text: 'Successfully Updated Moota',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'payment',
						title: 'Moota',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingMoota = false;
			};
			integrationApi.updateMoota(id, params, callback, errorCallback);
		},
		editMidtrans(id) {
			const midtrans = this.accounts.find(curr => curr._id === id);
			this.selectedAccount = midtrans;
			this.isMidtransFormVisible = true;
		},
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
			isFetching: 'settings/isFetching',
			accounts: 'settings/accounts',
		}),
		mootaAccounts() {
			return this.accounts.filter(account => account.name === 'moota');
		},
		midtransAccounts() {
			return this.accounts.filter(account => account.name === 'midtrans');
		},
	},
	created() {
		if (!this.isFetching) {
			this.fetchAccounts({ get_details: true });
		}
	},
};
</script>
